<div class="widget-container" #SankeyBeesWarmChart>
    <app-sankey-beeswarm-chart
    [headerConfig]="item.config?.widget_header_config"
    [heading]="heading"
    [config]="config"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    [triageTotaldata]="triageTotaldata"
    [height]="550"
    >
    </app-sankey-beeswarm-chart>
</div>
